import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllLayananFieldByLayananID = createAsyncThunk(
  "layananField/GetAllLayananFieldByLayananID",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/layanan_field/get_by_layanan_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllLayananField = createAsyncThunk(
  "layananField/GetAllLayananField",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/layanan_field/all?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleLayananField = createAsyncThunk(
  "layananField/GetSingleLayananField",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/layanan_field/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateLayananField = createAsyncThunk(
  "layananField/CreateLayananField",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/layanan_field`,
        {
          nama: data.nama,
          id_layanan: data.id_layanan,
          id_field: data.id_field,
          is_mandatory: data.is_mandatory,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditLayananField = createAsyncThunk(
  "layananField/EditLayananField",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/layanan_field/${data.id}`,
        {
          nama: data.nama,
          id_layanan: data.id_layanan,
          id_field: data.id_field,
          is_mandatory: data.is_mandatory,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteLayananField = createAsyncThunk(
  "layananField/DeleteLayananField",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/layanan_field/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(
          `${api}master/layanan_field/all?${data.url}`,
          {
            headers: {
              Authorization: data.token,
            },
          }
        );

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const layananFieldSlice = createSlice({
  name: "layananField",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all Layanan field by layanan id
    builder.addCase(GetAllLayananFieldByLayananID.pending, loadingHandler);
    builder.addCase(GetAllLayananFieldByLayananID.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananFieldByLayananID.rejected, rejectedHandler);
    // get all Layanan field
    builder.addCase(GetAllLayananField.pending, loadingHandler);
    builder.addCase(GetAllLayananField.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananField.rejected, rejectedHandler);
    // get Single Layanan field
    builder.addCase(GetSingleLayananField.pending, loadingHandler);
    builder.addCase(GetSingleLayananField.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleLayananField.rejected, rejectedHandler);
    // create Layanan field
    builder.addCase(CreateLayananField.pending, loadingHandler);
    builder.addCase(CreateLayananField.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateLayananField.rejected, rejectedHandler);
    // edit Layanan field
    builder.addCase(EditLayananField.pending, loadingHandler);
    builder.addCase(EditLayananField.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditLayananField.rejected, rejectedHandler);
    // delete Layanan field
    builder.addCase(DeleteLayananField.pending, loadingHandler);
    builder.addCase(DeleteLayananField.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteLayananField.rejected, rejectedHandler);
  },
});

export const { reset } = layananFieldSlice.actions;
export default layananFieldSlice.reducer;
